module.exports = __webpack_public_path__ + "img/symbol.b3c3cb74.svg";